var ResourcesVideo = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.resources-videos').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                // Remove this lines this and the next line
                console.log('Instance of resources-videos initialized with id and view: ', id, view);
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

ResourcesVideo();
